module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/google-play-store-ja-6af82cdbe5a1f6f05b43d972b66a4050.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/google-play-store-ja.svg
// module id = LMu0
// module chunks = 24